import React, { FC, useState, useEffect } from 'react';
import { apiService } from 'utils/api';
import SurgeApplyNowSection from '../surge-tabs/surge-apply-now';
import SurgeScheduleSection from '../surge-tabs/surge-schedule';
import { ScheduleSurgePayload, SurgeTabProps } from '../surge-tabs/types';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';

const GeneralSurgeSchedule: FC<SurgeTabProps> = ({ confirm, setLoading, onClose }) => {
  const [value, setValue] = useState({} as ScheduleSurgePayload);

  const setGeneralSurge = async (data?: ScheduleSurgePayload) => {
    try {
      const url = 'logistics/super-admin/surge/general/schedule';
      const res = await apiService.post(url, { data });
      const history = res?.data?.general_surge_history;
      return history;
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (confirm === 'Schedule') {
      (async () => {
        try {
          setLoading(true);
          await setGeneralSurge(value);
          toast(<ToastMessage type='success' message='Updated successfully' />);
          onClose();
        } catch (error) {
          toast(<ToastMessage type='error' message='There was an error updating surge' />);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [confirm]);

  return (
    <div>
      <SurgeApplyNowSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
        hideRemoveSurge
      />
      <SurgeScheduleSection
        value={value}
        setValue={(newVal) => setValue({ ...value, ...newVal })}
      />
    </div>
  );
};

export default GeneralSurgeSchedule;
